class Tabs extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.tabsClickFunction()
  }

  showTabContent(tab) {
    const indexTab = tab.dataset.tab;
    const tabContents = this.querySelectorAll(".tab-content");
    
    if (tabContents.length > 0) {
      const indexTabContent = this.querySelector(`.tab-content[data-tab="${indexTab}"]`);

      tabContents.forEach(content => {
        content.classList.remove("show");
      });
  
      indexTabContent.classList.add("show");
    } else {
      const tabContents2 = this.querySelectorAll(".tab-carousel");
      const indexTabContent = this.querySelector(`.tab-carousel[data-tab="${indexTab}"]`);

      tabContents2.forEach(content => {
        content.classList.remove("show");
      });
  
      indexTabContent.classList.add("show");
    }
  }

  tabsClickFunction() {
    const titles = this.querySelectorAll(".tab-title");
  
    titles.forEach(tabTitle => {
      tabTitle.addEventListener("click", () => {
        titles.forEach(element => {
          element.dataset.active = "false";
        });
  
        tabTitle.dataset.active = "true";
        this.showTabContent(tabTitle);
      });
    });
  }
}

customElements.define("products-tabs", Tabs)